import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FileText, Plus, X } from "lucide-react";
import { api, formatApiError } from "../lib/api";

export default function Documenti() {
  const [items, setItems] = useState(null);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", note: "" });
  const [loading, setLoading] = useState(false);

  const load = () => api.get("/documents").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/documents", form);
      toast.success("Documento aggiunto");
      setForm({ name: "", note: "" });
      setOpen(false);
      load();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Errore");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="documenti-page" className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-display text-3xl font-bold text-[#0A192F]">Documenti</h1>
          <p className="mt-1 text-slate-600">Tieni traccia dei documenti delle tue pratiche.</p>
        </div>
        <button data-testid="documenti-add-btn" onClick={() => setOpen(!open)} className="flex items-center gap-2 rounded-full bg-[#10B981] px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#059669]">
          {open ? <X className="h-4 w-4" /> : <Plus className="h-4 w-4" />} {open ? "Chiudi" : "Aggiungi"}
        </button>
      </div>

      {open && (
        <form onSubmit={submit} data-testid="documenti-form" className="space-y-4 rounded-2xl border border-slate-200 bg-white p-6">
          <input data-testid="documento-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Nome documento (es. Carta d'identità)" className="w-full rounded-xl border border-slate-200 px-4 py-3 outline-none focus:ring-2 focus:ring-[#10B981]" />
          <input data-testid="documento-note" value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} placeholder="Nota (facoltativa)" className="w-full rounded-xl border border-slate-200 px-4 py-3 outline-none focus:ring-2 focus:ring-[#10B981]" />
          <button data-testid="documento-submit" disabled={loading} className="rounded-full bg-[#0A192F] px-6 py-2.5 text-sm font-semibold text-white disabled:opacity-60">
            {loading ? "Salvataggio..." : "Salva documento"}
          </button>
        </form>
      )}

      {items === null ? (
        <div className="py-20 text-center text-slate-400">Caricamento...</div>
      ) : items.length === 0 ? (
        <div data-testid="documenti-empty" className="rounded-2xl border border-dashed border-slate-300 bg-white py-16 text-center">
          <FileText className="mx-auto h-10 w-10 text-slate-300" />
          <p className="mt-4 font-semibold text-[#0A192F]">Nessun documento</p>
          <p className="mt-1 text-sm text-slate-500">Aggiungi i documenti utili alle tue pratiche.</p>
        </div>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2">
          {items.map((d) => (
            <div key={d.id} data-testid={`documento-${d.id}`} className="flex items-start gap-4 rounded-2xl border border-slate-200 bg-white p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#10B981]/10">
                <FileText className="h-5 w-5 text-[#10B981]" />
              </span>
              <div>
                <p className="font-semibold text-[#0A192F]">{d.name}</p>
                {d.note && <p className="text-sm text-slate-500">{d.note}</p>}
                <p className="mt-1 text-xs text-slate-400">{new Date(d.created_at).toLocaleDateString("it-IT")}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
